import { DeliveryTime } from '@/features/orders/types/app'
import dayjs, { ManipulateType } from 'dayjs'

export const shiftDeliveryTime = (
    deliveryTime: DeliveryTime,
    shiftValue: number,
    timeUnit: ManipulateType
): DeliveryTime => {
    const start = dayjs(deliveryTime.start).add(shiftValue, timeUnit).format()
    const end = dayjs(deliveryTime.end).add(shiftValue, timeUnit).format()

    return {
        start,
        end,
        type: deliveryTime.type,
    }
}
